import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from 'react';

export const HeroBannerTimeline = (props) => {

    const sc = props.slice.primary;

    const qfs = props.slice.items;

    const co = props.context;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }

    return (
        <section className={"hero-banner relative"}>
            
            <div className="wrapper pt-8">
                <div className="w-full md:w-3/5 md:mt-12 m-auto">
                    <div className="text-center"><PrismicRichText field={sc.section_title.richText} /></div>
                    <div className="text-center"><PrismicRichText field={sc.header_content.richText} /></div>
                </div>
            </div>
            <section className="relative bg-gradient-to-t from-grey-light to-white">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 200"
                width="100%"
                height="100"
                preserveAspectRatio="none"
                className="md:block absolute -bottom-[3px] md:h-[200px] xl:w-full pointer-events-none">
                <path d="M0 41.4s263.2-58.1 503.2-17.7c252.4 42.5 600.8 96.9 845.4 8.4L1440 0v300H0V41.4Z" fill="#fff"/>
                </svg>
                <div className="wrapper">
                    <div className="w-full md:w-3/5 my-12 m-auto">
                        <GatsbyImage loading="eager" image={getImage(co.data.meta_image)} className="rounded-3xl shadow-2xl self-end" alt={co.data.meta_image.alt ? co.data.meta_image.alt : sc.section_title.text} />
                    </div>
                </div>
            </section>
            <section className="bg-white">
                <div className="wrapper pt-8">
                        {/* <PrismicRichText field={sc.header_content.richText} /> */}
                        <div className="w-full md:w-4/5 m-auto mb-10 pb-8 border-b border-grey-md flex flex-col md:flex-row justify-between gap-0 md:gap-8 text-left md:text-center">
                            {qfs.map((qf, index) => {
                                return (
                                    <div key={index} className="qf"><i className="fa fa-light fa-circle-check mr-2 text-green" /><PrismicRichText field={qf.quick_fact.richText} components={components} /></div>
                                )
                            })}
                        </div>
                        <div className="w-full md:w-4/5 m-auto mb-20 text-left md:text-center"><PrismicRichText field={sc.section_content.richText} /></div>
                    
                </div>
            </section>
        </section>
            
    );
}

